<template>
  <div class="charing-center-page-container">
    <div
      class="coupons-view-mask"
      v-show="isCouponsView"
      @click="viewClose"
    />
    <transition name="slide-up">
      <div
        class="coupons-view"
        v-show="isCouponsView"
        @click.self="viewClose"
      >
        <div class="title">
          <p>请选择优惠券</p>
          <div
            class="icon_del"
            @click="viewClose"
          >
            <img
              style="width: 22px; height: 22px;"
              src="../../../assets/img/icon_x.png"
            >
          </div>
        </div>
        <div class="scroll-container">
          <div
            class="cards"
            v-for="(item,index) in couponsList"
            :key="index"
            @click="selectCoupon(index,item)"
          >
            <div class="cards-name">
              <div class="caeds-num">{{ item.deductibleAmountYuan % 1 === 0 ? Math.floor(item.deductibleAmountYuan) + '元' : item.deductibleAmountYuan + '元' }}</div>
              <div class="use-num">满{{ Math.floor(item.usageThresholdNumYuan) }}元可用</div>
            </div>
            <div class="cards-info">
              <div class="cards-name">{{ item.agencyGoodsName }}</div>
              <div class="end-time">{{ item.expirationTime }}过期</div>
            </div>
            <div class="select-btn">
              <img
                v-if="index === selectedCouponIndex && selectedCouponIndex !== -1"
                src="../../../assets/img/icon_active.png"
              >
              <img
                v-else
                src="../../../assets/img/icon_unActive.png"
              >
            </div>
          </div>
        </div>
        <div
          class="pay-btn"
          @click="chooseCoupon"
        >确定</div>
      </div>
    </transition>
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="init"
    >
      <div class="charing-center-page">
        <div class="charing-center-page-bg" />
        <div style="position: relative; z-index: 2">
          <div
            id="charing-center-page-header"
            class="charing-center-page-header"
          >
            <div class="account-wrap">
              <div class="account-wrap-title">充值账号</div>
              <div
                class="account-wrap-account"
                @click="handleAccountClick"
              >
                <span v-if="form.chargePhone">{{
                  formatPhone(form.chargePhone)
                }}</span>
                <span
                  class="account-value-tips"
                  v-else
                >请输入手机号</span>
                <img
                  class="account-wrap-icon"
                  src="@/assets/img/chargingVoucher/icon-edit.png"
                >
              </div>
            </div>
          </div>
          <div class="buy-coupon">
            <div
              id="coupon-provider-wrap"
              class="coupon-provider-wrap"
              :class="{
                before: showProvideTabBefore,
                after: showProvideTabAfter,
              }"
            >
              <div class="coupon-provider-tabs">
                <div
                  id="scroll-box-before"
                  class="scroll-box-before"
                />
                <div
                  v-for="(item, index) in provideTabOptions"
                  :key="item.key"
                  class="coupon-provider-tab"
                  :class="{
                    active: item.key === curProviderTab.key,
                  }"
                  @click="handleProviderTabClick(item)"
                >
                  <template v-if="item.key === curProviderTab.key">
                    <img
                      v-if="index === 0"
                      class="coupon-provider-tab-bg left"
                      src="@/assets/img/chargingVoucher/coupon-provider-selected-bg.png"
                    >
                    <img
                      v-else-if="
                        index >= 3 && index === provideTabOptions.length - 1
                      "
                      class="coupon-provider-tab-bg right"
                      style="scale: -1 1"
                      src="@/assets/img/chargingVoucher/coupon-provider-selected-bg.png"
                    >
                    <img
                      v-else
                      class="coupon-provider-tab-bg"
                      src="@/assets/img/chargingVoucher/coupon-provider-selected-bg-middle.png"
                    >
                  </template>
                  <img
                    class="coupon-provider-tab-icon"
                    :src="item.iconUrl"
                  >
                  <span class="coupon-provider-tab-text">{{ item.text }}</span>
                </div>
                <div
                  id="scroll-box-after"
                  class="scroll-box-after"
                />
              </div>
            </div>

            <div class="p-27-18-18-18">
              <div
                id="coupon-type-wrap"
                class="coupon-type-wrap"
              >
                <div class="coupon-type-tabs">
                  <div
                    v-for="item in curProviderTab.chargeCouponTypeOptions"
                    :key="item.key"
                    class="coupon-type-tab"
                    :class="{
                      active: item.key === curChargeCouponTypeTab,
                    }"
                    @click="handleChargeCouponTypeTabClick(item)"
                  >
                    <img
                      v-if="item.key === curChargeCouponTypeTab"
                      class="coupon-type-tab-bg"
                      :src="curChargeCouponTypeTabBg"
                    >
                    <div
                      class="coupon-type-tab-title"
                      v-if="chargeCouponTypeOptionsLength <= 2"
                    >
                      {{ item.subTitle }}{{ item.title }}
                    </div>
                    <template v-else>
                      <div class="coupon-type-tab-title">
                        {{ item.title }}
                      </div>
                      <div class="coupon-type-tab-sub-title">
                        {{ item.subTitle }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <div
                id="coupon-list-wrap"
                class="coupon-list-wrap"
              >
                <div class="buy-coupon-list">
                  <div
                    v-for="item in rights"
                    :key="item.id"
                    class="buy-coupon-item"
                    :class="{
                      active:
                        item.agencyCouponConfigCode ===
                        form.agencyCouponConfigCode,
                      disabled: !item.quantity || item.quantity === 0,
                    }"
                    @click="() => handleCouponClick(item)"
                  >
                    <div
                      class="buy-coupon-discount"
                      v-if="item.discount"
                    >
                      {{ `${item.discount}` }}折
                    </div>
                    <div class="buy-coupon-value">
                      {{ item.productAmountYuan }}元
                    </div>
                    <div class="buy-coupon-price">
                      售价{{ item.discountAmountYuan }}元
                    </div>
                    <div class="buy-coupon-price-remark">
                      {{ item.remark }}
                    </div>
                    <div class="buy-coupon-stock">
                      剩余：{{ item.quantity || 0 }}张
                    </div>
                  </div>
                  <div
                    v-if="!rights.length"
                    class="blank-tips"
                  >
                    补充中，请稍候
                  </div>
                </div>
              </div>

              <div class="buy-coupon-number-wrap">
                <div class="buy-coupon-number-wrap-title">购买数量</div>
                <NumberInput
                  :value="form.buyNum"
                  :min="1"
                  :max="10"
                  @left="handleNumberInputLeft"
                  @right="handleNumberInputRight"
                  @middle="handleNumberInputMiddleClick"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="h-210" />
        <div
          v-if="$parent.showBottomNavBar"
          class="h-bottom-nav"
        />
      </div>
    </van-pull-refresh>

    <div class="bottom-btn-wrap">
      <div class="coupon-provider-tips">
        <p>温馨提示：{{ curProviderTab.remind || "暂无" }}</p>
        <span
          class="link-text"
          @click="showCouponTips()"
        >更多说明</span>
      </div>
      <div
        class="buy-btn-wrap"
        v-if="isAuthorize"
      >
        <div class="buy-btn-value">
          <p v-if="!isCouponLoading">
            合计支付：<span>￥<i>{{ totalAmount }}</i> 元</span>
          </p>
          <p
            v-else
            class="loading-text"
          >
            合计支付：<van-loading
              size="15px"
              type="spinner"
            />
          </p>
          <p v-if="!isCouponLoading">
            已优惠：<span>￥{{ discountAmountValue }}元</span>
          </p>
          <p
            v-else
            class="loading-text"
          >
            已优惠：<van-loading
              size="15px"
              type="spinner"
            />
          </p>
        </div>
        <div
          class="buy-btn"
          @click="handleBuyBtnClick"
        >立即支付</div>
      </div>
      <div
        v-if="$parent.showBottomNavBar"
        class="h-bottom-nav"
      />
    </div>

    <!-- 支付确认弹窗 -->
    <PayCheckPopup
      ref="refPayCheckPopup"
      :charge-number="form.chargePhone"
      :provider-name="curProviderTab.desc"
      @confirm="handlePayCheckPopupConfirm"
      @cancel="handlePayCheckPopupCancel"
    />
    <!-- 支付结果弹窗 -->
    <PayResultPopup
      ref="refPayResultPopup"
      @confirm="toMyCouponsPage"
    />
    <!-- 输入弹窗 -->
    <InputPopup
      ref="refInputPopup"
      :min="1"
      :max="10"
      @confirm="handleInputPopupConfirm"
      @cancel="handleInputPopupCancel"
    />
    <!-- 用券提示弹窗 -->
    <TipsBottomPopup
      ref="refTipsBottomPopup"
      :more-description="curProviderTab.moreDescription"
    />
    <!-- 提示弹窗 -->
    <TipsPopup
      ref="refTipsPopup"
      @confirm="(fn) => fn()"
    />
    <!-- 特惠券包悬浮按钮 -->
    <SpecialCouponBtn
      ref="refSpecialCouponBtn"
      v-if="isAuthorize"
      :agency-code="agencyCode"
    />
    <!-- 操作指引 -->
    <OperaGuide
      v-if="showGuide"
      ref="refOperaGuide"
      :steps="operaGuideSteps"
      @nextStep="handleNextStep"
      @guideEnd="handleGuideEnd"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import PayCheckPopup from '../../chargingVoucher/components/PayCheckPopup.vue';
import PayResultPopup from '../../chargingVoucher/components/PayResultPopup.vue';
import InputPopup from '../../chargingVoucher/components/InputPopup.vue';
import {
  queryChargeCouponList,
  createChargeCouponOrder,
  prePayChargeCouponOrder,
  queryChargeCouponDetail,
  queryAgencyDetail,
  queryRightCouponProviderConfig,
  queryIsGuide,
  updateIsGuide,
  getCouponApi
} from '../common/api.js';
import Pay from '@/common/weixin.js';
import NumberInput from '../../chargingVoucher/components/NumberInput.vue';
import TipsBottomPopup from './TipsBottomPopup.vue';
import TipsPopup from '../../chargingVoucher/components/TipsPopup.vue';
import { REGEX_PHONE } from '@/common/regex';
import SpecialCouponBtn from '../../chargingVoucher/components/SpecialCouponBtn.vue';
import curChargeCouponTypeTabBg1 from '@/assets/img/chargingVoucher/coupon-type-selected-bg-1.png';
import curChargeCouponTypeTabBg2 from '@/assets/img/chargingVoucher/coupon-type-selected-bg-2.png';
import curChargeCouponTypeTabBg3 from '@/assets/img/chargingVoucher/coupon-type-selected-bg-3.png';
import curChargeCouponTypeTabBg4 from '@/assets/img/chargingVoucher/coupon-type-selected-bg-4.png';
import OperaGuide from '../../chargingVoucher/components/OperaGuide.vue';

class CreateForm {
  orderPhone = ''; // 下单账号手机
  chargePhone = ''; // 充值账号手机
  couponConfigCode = ''; // 充电券配置券Code
  agencyCouponConfigCode = ''; // 代理券配置code
  buyNum = 1; // 购买数量
  payAmountYuan = 0; // 支付金额（单位：元）
  latitude = 22.557091; // 纬度
  longitude = 114.070306; // 经度
}

export default {
  name: 'CharingCenter',
  components: {
    PayCheckPopup,
    PayResultPopup,
    InputPopup,
    NumberInput,
    TipsBottomPopup,
    TipsPopup,
    SpecialCouponBtn,
    OperaGuide
  },
  data() {
    const operaGuideSteps = [
      {
        id: 'charing-center-page-header',
        text: '点击该区域可修改商品充值的手机号',
        pointPosition: 'left',
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      {
        id: 'coupon-provider-wrap',
        text: '向左滑动该区域，可选择更多服务商',
        showHand: true,
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      {
        id: 'coupon-type-wrap',
        text: '可选择需要购买的商品类型',
        pointPosition: 'left',
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      {
        id: 'coupon-list-wrap',
        text: '可选择需要购买的商品内容',
        top: 0,
        left: 0,
        width: 0,
        height: 0
      }
    ];

    return {
      // 优惠券满减价格
      discountPrice: 0,
      // 是否选中的优惠券下单
      isChooseCoupon: false,
      // 优惠券列表数据
      couponsList: [],
      // 是否显示优惠券选择窗口
      isCouponsView: false,
      // 当前选中的优惠券索引
      selectedCouponIndex: 0,
      // 当前选中优惠券的数据
      couponData: {},
      // 供应商列表
      provideTabOptions: [],
      // 当前供应商
      curProviderTab: {},
      // 操作指引步骤
      operaGuideSteps,
      // 充电券列表
      rightCouponConfigList: {},
      // 表单
      form: new CreateForm(),
      // 已选择的充电券
      selectedCoupon: {},
      // 订单号
      orderNo: '',
      // 是否显示下拉刷新
      showPullRefreshLoading: false,
      // 商品类型
      curChargeCouponTypeTab: '',
      // 代理商是否能下单
      isAuthorize: false,
      // 代理商code
      agencyCode: '',
      // 展示指引
      showGuide: false,
      // 显示供应商tab遮盖
      showProvideTabBefore: false,
      showProvideTabAfter: true,
      // 展示签到按钮
      showSignInBtn: false,
      // 充电券加载状态
      isLoading: false,
      // 优惠券加载状态
      isCouponLoading: false
    };
  },
  computed: {
    rights() {
      let arr = [];
      try {
        arr = this.rightCouponConfigList[this.curProviderTab?.key || ''] || [];
      } catch (error) {
        arr = [];
      }
      return arr?.filter(
        (item) => item.chargeCouponType === this.curChargeCouponTypeTab
      );
    },
    // 获取可用优惠券的对于价格参数
    findCouponsNum() {
      return this.form.buyNum * this.selectedCoupon.productAmountYuan || 0;
    },
    // 选中优惠券下单取原价支付减去满减价格
    isUseOriginalPrice() {
      return (
        Number(
          (
            this.form.buyNum * this.selectedCoupon.productAmountYuan - this.couponData.deductibleAmountYuan || 0
          ).toFixed(2)
        ) || 0
      );
    },
    totalAmount() {
      // this.couponData.deductibleAmountYuan
      // this.selectedCoupon.productAmountYuan
      if (this.isChooseCoupon) {
        return (
          Number(
            (
              this.form.buyNum * this.selectedCoupon.productAmountYuan - this.couponData.deductibleAmountYuan || 0
            ).toFixed(2)
          ) || 0
        );
      } else {
        return (
          Number(
            (
              this.form.buyNum * this.selectedCoupon.discountAmountYuan || 0
            ).toFixed(2)
          ) || 0
        );
      }
    },
    discountAmountValue() {
      if (this.isChooseCoupon) {
        return Number(parseFloat(this.couponData.deductibleAmountYuan || 0).toFixed(2));
      } else {
        return (
          Number(
            (
              this.form.buyNum * this.selectedCoupon.productAmountYuan -
              this.form.buyNum * this.selectedCoupon.discountAmountYuan || 0
            ).toFixed(2)
          ) || 0
        );
      }
    },
    isCardType() {
      return ['PAY_OFF_CARD', 'SERVICE_OFF_CARD', 'MEMBER_CARD'].includes(
        this.curChargeCouponTypeTab
      );
    },
    chargeCouponTypeOptionsLength() {
      return this.curProviderTab?.chargeCouponTypeOptions?.length || 0;
    },
    curChargeCouponTypeTabBg() {
      switch (this.chargeCouponTypeOptionsLength) {
        case 1:
          return curChargeCouponTypeTabBg1;
        case 2:
          return curChargeCouponTypeTabBg2;
        case 3:
          return curChargeCouponTypeTabBg3;
        case 4:
          return curChargeCouponTypeTabBg4;
        default:
          return curChargeCouponTypeTabBg4;
      }
    }
  },
  watch: {
    // 监听购买商品数量变化，获取对应优惠券
    'form.buyNum': {
      handler: debounce(function(newVal, oldVal) {
        // 不再设置loading状态，因为在点击事件中已经设置
        // this.isCouponLoading = true;
        this.getCoupons();
      }, 500), // 防抖500ms，避免频繁请求
      immediate: false // 初始化时不请求
    },
    rights: {
      handler(val) {
        val.forEach((item) => {
          if (item.couponConfigCode === this.form.couponConfigCode) {
            this.selectedCoupon.productAmountYuan = item.productAmountYuan;
            this.selectedCoupon.discountAmountYuan = item.discountAmountYuan;
          }
        });
      },
      immediate: true
    },
    'form.agencyCouponConfigCode'(newVal) {
      if (!newVal) {
        this.form.couponConfigCode = '';
        this.couponData = {};
        console.log('清空代理券配置code');
      } else {
        this.getCoupons();
      }
    },
    isLoading(newVal) {
      if (!newVal) {
        this.operaGuideSteps.forEach((item) => {
          this.getTargetInfo(item);
        });
        this.$set(this, 'operaGuideSteps', [...this.operaGuideSteps]);
      }
    },
    showGuide(newVal) {
      if (newVal) {
        this.operaGuideSteps.forEach((item) => {
          this.getTargetInfo(item);
        });
        this.$set(this, 'operaGuideSteps', [...this.operaGuideSteps]);
      }
    }
  },
  created() {
    this.form.agencyCouponConfigCode = '';
    this.selectedCoupon = {};
    this.agencyCode = localStorage.getItem('_encryptAgencyCode') || '';
    this.getMenuConfig();
    this.getLocation();
    this.toQueryIsGuide();
  },
  mounted() {
    this.agencyCode = localStorage.getItem('_encryptAgencyCode') || '';
    this.toQueryAgencyDetail();

    const phone = localStorage.getItem('_phone') || '';
    if (phone) {
      this.form.orderPhone = phone;
      this.form.chargePhone = phone;
    }

    const chargePhone = localStorage.getItem('_chargePhone') || '';
    if (chargePhone) {
      this.form.chargePhone = chargePhone;
    }

    let isCallBack = localStorage.getItem('_isCallBack') || '';
    let orderNo = localStorage.getItem('_orderNo') || '';
    if (isCallBack === 'undefined') {
      isCallBack = null;
      localStorage.removeItem('_isCallBack');
    }
    if (orderNo === 'undefined') {
      orderNo = null;
      localStorage.removeItem('_orderNo');
    }

    if (isCallBack && orderNo) {
      this.checkPay(orderNo);
    }

    this.createOberser();
  },
  methods: {
    // 获取可用优惠券数据
    getCoupons() {
      const params = {
        isUse: false,
        productAmount: this.findCouponsNum,
        agencyCode: this.agencyCode || ''
      };

      // 不再设置loading状态，因为在点击事件中已经设置
      // this.isCouponLoading = true;

      getCouponApi(params)
        .then(res => {
          this.couponsList = res;
          // 默认选中第一个优惠券
          if (res.length > 0) {
            this.selectedCouponIndex = 0;
            this.couponData = res[0];
            this.isChooseCoupon = true;
          } else {
            this.isChooseCoupon = false;
          }
        })
        .catch(error => {
          console.error('获取优惠券列表失败:', error);
          this.$toast.fail('获取优惠券失败');
        })
        .finally(() => {
          // 隐藏加载状态
          this.isCouponLoading = false;
        });
    },
    // 选择优惠券
    selectCoupon(index, item) {
      // 如果点击的是已经选中的优惠券，则取消选中
      if (this.selectedCouponIndex === index) {
        this.selectedCouponIndex = -1; // -1表示没有选中的优惠券
        this.couponData = {};
        this.isChooseCoupon = false;
      } else {
        this.selectedCouponIndex = index;
        this.couponData = item;
        this.isChooseCoupon = true;
      }
    },
    // 确认选中优惠券
    chooseCoupon() {
      this.isCouponsView = false;
      this.toPrePay();
    },
    // 关闭优惠券窗口试图
    viewClose() {
      this.isCouponsView = false;
    },
    init() {
      this.showPullRefreshLoading = false;
      this.toQueryAgencyDetail();
      this.$refs.refSpecialCouponBtn.toQuerySpecialRote();
      this.getMenuConfig();
      this.getLocation();
    },
    createOberser() {
      const beforeObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.showProvideTabBefore = !entry.isIntersecting;
      });
      const beforeDOM = document.getElementById('scroll-box-before');
      beforeObserver.observe(beforeDOM);

      const afterObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.showProvideTabAfter = !entry.isIntersecting;
      });
      const afterDOM = document.getElementById('scroll-box-after');
      afterObserver.observe(afterDOM);
    },
    toQueryAgencyDetail() {
      const param = {
        encryptAgencyCode: this.agencyCode || ''
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      queryAgencyDetail(param).then((res) => {
        if (res.status !== 'Enable') {
          this.isAuthorize = false;
          this.toDefaultBlankPage();
        } else {
          this.isAuthorize = true;
          this.toQueryChargeCouponList();
          if (res.titleStatus == '1' && res.title) {
            document.title = res.title;
          } else {
            document.title = '购券中心';
          }
        }
        this.$toast.clear();
      });
    },
    // 查询充电券列表
    toQueryChargeCouponList() {
      const param = {
        encryptAgencyCode: this.agencyCode || ''
      };
      this.isLoading = true;
      queryChargeCouponList(param).then((res) => {
        if (res) {
          this.form.orderPhone = res.phone || '';
          localStorage.setItem('_phone', res.phone);
          if (!this.form.chargePhone) {
            this.form.chargePhone =
              localStorage.getItem('_chargePhone') || res.phone || '';
          }
          localStorage.setItem('_chargePhone', this.form.chargePhone);

          this.rightCouponConfigList = res.rightCouponConfigList;
          this.isLoading = false;
          setTimeout(() => {
            this.operaGuideSteps.forEach((item) => {
              this.getTargetInfo(item);
            });
            this.$set(this, 'operaGuideSteps', [...this.operaGuideSteps]);
          });
        }
      });
    },
    // 选择供应商
    handleProviderTabClick(item) {
      if (this.curProviderTab.key === item.key) return;
      this.curProviderTab = item;
      this.curChargeCouponTypeTab =
        this.curProviderTab.chargeCouponTypeOptions[0].key;

      this.form.agencyCouponConfigCode = '';
      this.selectedCoupon = {};
      this.toQueryChargeCouponList();
    },
    // 选择充电券类型
    handleChargeCouponTypeTabClick(item) {
      if (this.curChargeCouponTypeTab === item.key) return;
      this.curChargeCouponTypeTab = item.key;
      this.form.agencyCouponConfigCode = '';
      this.selectedCoupon = {};
      this.toQueryChargeCouponList();
    },
    // 选择充电券
    handleCouponClick(item) {
      // 2024.08.27 小桔充电券不可选中
      if (this.curProviderTab.key === 'XIAOJU') {
        this.$toast('该充电券升级维护中，敬请期待');
        return;
      }

      if (!item.quantity || item.quantity === 0) {
        this.$toast('该券已售罄，将在1天内补充，敬请期待');
        return;
      } else {
        if (this.form.agencyCouponConfigCode === item.agencyCouponConfigCode) {
          this.form.agencyCouponConfigCode = '';
          this.selectedCoupon = {};
        } else {
          this.selectedCoupon = item;
          this.form.couponConfigCode = item.couponConfigCode;
          this.form.agencyCouponConfigCode = item.agencyCouponConfigCode;
        }
      }
    },
    // 展示提醒弹窗
    showCouponTips() {
      this.$refs.refTipsBottomPopup.openPopup();
    },
    // 下单
    handleBuyBtnClick() {
      if (!this.form.chargePhone) {
        this.$toast('请输入充值账号');
        return;
      }
      if (!REGEX_PHONE.test(this.form.chargePhone)) {
        this.$toast('充值账号应为有效手机号');
        return;
      }
      if (!this.form.agencyCouponConfigCode) {
        this.$toast('请选择充电券');
        return;
      }
      if (this.form.buyNum > this.selectedCoupon.quantity) {
        this.$toast('购买数量不能大于剩余数量');
        return;
      }
      if (this.selectedCoupon.isPrompt == 1) {
        this.$refs.refTipsPopup.openPopup({
          showCancelBtn: true,
          cancelBtnText: '重新选择',
          confirmBtnText: '确认购买',
          text: this.selectedCoupon.promptContent || '',
          confirm: () => {
            // 兼容旧有逻辑
            if (!this.form.orderPhone) {
              this.form.orderPhone = this.form.chargePhone;
            }
            this.getCoupons();
            this.$refs.refPayCheckPopup.openPopup();
          }
        });
        return;
      }

      // 兼容旧有逻辑
      if (!this.form.orderPhone) {
        this.form.orderPhone = this.form.chargePhone;
      }
      this.getCoupons();
      this.$refs.refPayCheckPopup.openPopup();
    },
    toPrePay() {
      const param = {
        ...this.form,
        chargePayType: 'WECHAT_PAY',
        payAmountYuan: this.isChooseCoupon ? this.isUseOriginalPrice : this.totalAmount,
        encryptAgencyCode: this.agencyCode || '',
        chargeOrderModel: 'AGENCY_SINGLE_CLASS',
        sharePhone: localStorage.getItem('_sharePhone') || '',
        relatedCouponId: this.isChooseCoupon ? this.couponData.couponId : ''
      };
      this.$toast.loading({
        message: '下单中...',
        forbidClick: true,
        duration: 0
      });
      createChargeCouponOrder(param, true)
        .then((res) => {
          if (res) {
            console.log('创建充电券订单成功');
            this.toPay(res);
          }
          this.$toast.clear();
        })
        .catch((err) => {
          this.$toast.clear();
          const message = err?.data?.message || '';
          if (message.includes('购买数量上限')) {
            this.$refs.refTipsPopup.openPopup({
              text: message
            });
          } else {
            this.$toast(message);
          }
        });
    },
    toPay(res) {
      this.form.agencyCouponConfigCode = '';
      this.selectedCoupon = {};
      this.orderNo = res.orderNo;
      localStorage.setItem('_chargePhone', this.form.chargePhone);
      this.toPrePayChargeCouponOrder(res);
    },
    async toPrePayChargeCouponOrder(res) {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      try {
        this.$toast.loading({
          message: '支付中...',
          forbidClick: true,
          duration: 0
        });
        const prepayRs = await prePayChargeCouponOrder({
          payType: envMap[this.$browserEnv], // 支付环境
          orderNo: res.orderNo,
          openId: this.$route.query.openId || null,
          encryptAgencyCode: this.agencyCode || ''
        });
        this.prePayHandle(prepayRs);
        this.$toast.clear();
      } catch (error) {
        console.log(error);
      }
    },
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };

      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },
    prePaySuccess() {
      if (this.isCardType) {
        this.$refs.refPayResultPopup.openPopup(
          '充电卡将在5分钟内发送到您的充值账户中，可前往目标充值账户中【我的权益】页面查看购买的充电卡。'
        );
      } else {
        this.$refs.refPayResultPopup.openPopup(
          '充电券将在5分钟内发送到您的充值账户中，可前往目标充值账户中【我的权益】页面查看购买的充电券。'
        );
      }
    },
    prePayFail() {
      this.$toast('支付失败');
    },
    // 修改充值账号
    handleAccountClick() {
      const param = {
        key: 'chargePhone',
        inputType: 'tel',
        text: '充值账号',
        value: this.form.chargePhone
      };
      this.$refs.refInputPopup.openPopup(param);
    },
    // 弹出输入弹窗
    handleInputPopupConfirm(param) {
      this.$refs.refInputPopup.closePopup();
      // 提前设置loading状态
      this.isCouponLoading = true;
      this.form[param.key] = param.value;
    },
    // 取消输入弹窗
    handleInputPopupCancel() {
      this.$refs.refInputPopup.closePopup();
      // 关闭loading状态
      this.isCouponLoading = false;
    },
    // 修改购买数量
    handleNumberInputLeft() {
      // 提前设置loading状态
      this.isCouponLoading = true;
      this.form.buyNum = Number(this.form.buyNum) - 1;
    },
    handleNumberInputRight() {
      // 提前设置loading状态
      this.isCouponLoading = true;
      this.form.buyNum = Number(this.form.buyNum) + 1;
    },
    handleNumberInputMiddleClick() {
      const param = {
        key: 'buyNum',
        inputType: 'number',
        text: '购买数量',
        value: this.form.buyNum
      };
      this.$refs.refInputPopup.openPopup(param);
    },
    // 格式化手机号
    formatPhone(val) {
      if (val) {
        const matches = /^(\d{3})(\d{4})(\d{4})$/.exec(val);
        if (matches) {
          return matches[1] + ' ' + matches[2] + ' ' + matches[3];
        }
        return val;
      }
    },
    // 检查支付结果
    async checkPay(orderNo) {
      const param = {
        orderNo: orderNo,
        encryptAgencyCode: this.agencyCode || ''
      };
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      queryChargeCouponDetail(param).then((res) => {
        if (res.orderStatus == 'PAID_WAIT') {
          this.prePayFail();
        } else {
          this.prePaySuccess();
          this.$toast.clear();
        }
        localStorage.removeItem('_isCallBack');
        localStorage.removeItem('_orderNo');
      });
    },
    handlePayCheckPopupConfirm() {
      this.$refs.refPayCheckPopup.closePopup();
      if (this.couponsList && this.couponsList.length > 0) {
        console.log('this.couponsList', this.couponsList);
        this.isCouponsView = true;
      } else {
        this.toPrePay();
      }
      // this.toPrePay();
    },
    // 支付方式取消
    handlePayCheckPopupCancel() {
      this.$refs.refPayCheckPopup.closePopup();
      this.handleAccountClick();
    },
    toDefaultBlankPage() {
      this.$router.replace({ name: 'ChargingVoucherAgencyDefaultBlank' });
    },
    // 跳转我的充电券
    async toMyCouponsPage() {
      let rightType = 'coupon';

      if (this.isCardType) {
        rightType = 'card';
      } else {
        rightType = 'coupon';
      }

      localStorage.setItem('_rightType', rightType);
      this.$parent.handleNavBarClick('MyCoupons');
    },
    getTargetInfo(dom) {
      if (!this.showGuide) return;
      const element = document.getElementById(dom.id);
      const rect = element.getBoundingClientRect();
      dom.width = rect.width;
      dom.height = rect.height;
      dom.top = rect.top;
      dom.left = rect.left;
      dom.borderRadius = '10px';

      if (['coupon-type-wrap'].includes(dom.id)) {
        dom.top = dom.top - 18;
        dom.width = dom.width + 24;
        dom.left = dom.left - 12;
      }
      if (['coupon-list-wrap'].includes(dom.id)) {
        dom.width = dom.width + 24;
        dom.left = dom.left - 12;
        dom.height = dom.height > 140 ? 140 : dom.height;
      }
    },
    // 下一步指引
    handleNextStep(step) {
      Window.scrollTo({
        top: step.top - 20,
        behavior: 'smooth'
      });
    },
    // 查询是否显示过买券指引
    toQueryIsGuide() {
      const param = {};
      queryIsGuide(param).then((res) => {
        if (res) {
          const data = res || {};
          this.showGuide = data?.isGuide == '0';
        }
      });
    },
    // 更新买券指引状态
    handleGuideEnd() {
      this.showGuide = false;
      const param = {};
      updateIsGuide(param);
    },
    // 获取菜单配置
    getMenuConfig() {
      const param = {
        encryptAgencyCode: this.agencyCode || ''
      };
      return queryRightCouponProviderConfig(param).then((res) => {
        if (res) {
          const data = res || {};
          console.log('getMenuConfig', data);
          this.provideTabOptions = data
            .filter((v) => v.enable === '1')
            .map((v) => {
              const chargeCouponTypeOptions = v.productTypeDTOS
                .filter((product) => product.enable === '1')
                .map((product) => ({
                  key: product.productType,
                  name: '商品类型',
                  title: product.mainTitle,
                  subTitle: product.subTitle
                }));

              return {
                text: v.menuName,
                desc: v.menuName,
                key: v.companyNo || '',
                iconUrl: v.iconUrl,
                remind: v.remind,
                moreDescription: v.moreDescription,
                chargeCouponTypeOptions
              };
            });
          // 优化交互
          const keyArr = this.provideTabOptions.map((v) => v.key);
          if (!this.curProviderTab) {
            this.curProviderTab = this.provideTabOptions[0];
          } else if (!keyArr.includes(this.curProviderTab.key)) {
            this.curProviderTab = this.provideTabOptions[0];
          } else {
            this.curProviderTab = this.provideTabOptions.find(
              (v) => v.key === this.curProviderTab.key
            );
          }
          this.curChargeCouponTypeTab =
          this.curProviderTab?.chargeCouponTypeOptions[0]?.key || '';
        }

        console.log(this.provideTabOptions);
      });
    },
    getLocation() {
      const _that = this;
      AMap.plugin('AMap.Geolocation', function() {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认：true
          timeout: 10000, // 设置定位超时时间，默认：无穷大
          showMarker: false, //  是否显示定位点，默认为true
          showCircle: false, //  是否显示定位精度圆，默认为true
          showButton: false //  是否显示定位按钮，默认为true
        });

        geolocation.getCurrentPosition(function(status, result) {
          if (status == 'complete') {
            onComplete(result);
          } else {
            onError(result);
          }
        });

        function onComplete(data) {
          // data是具体的定位信息
          console.log(data);
          const position = data.position || {
            lat: 22.557091, // 纬度
            lng: 114.070306 // 经度
          };
          _that.form.latitude = position.lat;
          _that.form.longitude = position.lng;
        }

        function onError(error) {
          // 定位出错
          console.log(error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../chargingVoucher/styles/CharingCenter.scss";

.charing-center-page-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.coupons-view-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9998;
}

.coupons-view {
  box-sizing: border-box;
  padding: 28px 32px;
  width: 100%;
  // height: 200px;
  background: #FFFFFF;
  border-radius: 20px 20px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99999;
  transition: transform 0.3s ease-out;
  transform: translateY(0);
  max-height: 60vh; // 最大高度为视口的60%
  overflow: hidden; // 外层容器隐藏溢出
  display: flex;
  flex-direction: column;

  &.hidden {
    transform: translateY(100%);
  }

  .title {
    height: 114px;
    border-bottom: 1px solid #E6E6E6;
    font-size: 32px;
    color: #383838;
    text-align: center;
    font-weight: 400;
    line-height: 114px;

    .icon_del {
      position: absolute;
      right: 40px;
      top: 8px;
    }
  }

  .scroll-container {
    flex: 1;
    overflow-y: auto;
    padding-right: 4px; // 为滚动条留出空间
    &::-webkit-scrollbar {
      width: 1px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }
  }

  .cards {
    margin-top: 32px;
    height: 192px;
    box-sizing: border-box;
    // min-height: calc(100vh - 114px);
    padding: 0 17px 0 12px;
    background-image: url('../../../assets/img/pic_available.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cards-name {
       margin-left: 14px;
       display: flex;
       flex-direction: column;
       justify-content: center;

      // max-width: ;
      .caeds-num {
        font-size: 48px;
        color: #FFFFFF;
        text-align: center;
      }

      .use-num {
        margin-top: 12px;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.36px;
        text-align: center;
        font-weight: 400;
      }
    }

    .cards-info {
      width: 320px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 16px;
      max-width: 50%;

      .cards-name {
        width: 100%;
        font-size: 32px;
        color: #665857;
        line-height: 1.2;
        word-break: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .end-time {
        margin-left: 14px;
        font-size: 24px;
        color: #998B8A;
        letter-spacing: 0.36px;
        font-weight: 400;
        line-height: 1.2;
        margin-top: 16px;
      }
    }

    .select-btn {
      display: flex;
      // justify-content: center;
      align-items: center;
      margin-right: 32px;
      width: 48px;
      height: 48px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .pay-btn {
    background: #FE7256;
    border-radius: 20px;
    font-size: 32px;
    color: #FFFFFF;
    text-align: center;
    font-weight: 400;
    padding: 23px 0;
    margin-top: 52px;
  }
}
</style>
